export default "__VITE_ASSET__CuvV2zjF__"